import { StockDocumentDetailsEditSection } from "./sections"
import { CommunicationSection } from "./sections"
export const ProjectDetailsEditSection = StockDocumentDetailsEditSection
export const ProjectCommunicationSection = CommunicationSection


// WEBPACK FOOTER //
// ./src/project/index.ts